/* KONSEI product detail: gallery, variants, quantities and direct checkout */
(function(){
'use strict';
function init(root){
  if(root.dataset.ksDetailReady)return;
  root.dataset.ksDetailReady='1';
  const select=root.querySelector('[data-konsei-variant-select]');
  const id=root.querySelector('[data-konsei-variant-id]');
  const price=root.querySelector('[data-variant-price]');
  const compare=root.querySelector('[data-variant-compare]');
  const discount=root.querySelector('[data-variant-discount]');
  const add=root.querySelector('[data-konsei-add-button]');
  const buy=root.querySelector('[data-konsei-buy-button]');
  const img=root.querySelector('[data-konsei-main-image]');
  const qty=root.querySelector('[data-ks-quantity]');
  root.querySelectorAll('[data-konsei-thumb]').forEach(thumb=>thumb.addEventListener('click',()=>{
    if(!img)return;
    if(thumb.dataset.size&&select){
      const option=Array.from(select.options).find(o=>o.textContent.includes(thumb.dataset.size+' ml'));
      if(option){select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));return}
    }
    img.src=thumb.dataset.image;img.alt=thumb.dataset.alt;
    root.querySelectorAll('[data-konsei-thumb]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));
  }));
  root.querySelector('[data-ks-qty-minus]')?.addEventListener('click',()=>{qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1)});
  root.querySelector('[data-ks-qty-plus]')?.addEventListener('click',()=>{qty.value=Math.min(50,(parseInt(qty.value,10)||1)+1)});
  qty?.addEventListener('change',()=>{qty.value=Math.min(50,Math.max(1,parseInt(qty.value,10)||1))});
  if(select){
    select.addEventListener('change',()=>{
      const option=select.options[select.selectedIndex];if(!option)return;
      const available=option.dataset.available==='true';
      if(id)id.value=option.value;
      if(price)price.textContent=option.dataset.price;
      if(compare){compare.textContent=option.dataset.compare||'';compare.hidden=!option.dataset.compare}
      if(discount){const off=parseInt(option.dataset.discount,10)||0;discount.textContent=off+'% OFF';discount.hidden=!off}
      if(img&&option.dataset.image){img.src=option.dataset.image;img.alt=option.dataset.imageAlt||'';root.querySelectorAll('[data-konsei-thumb]').forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.image===img.src)))}
      if(add){add.disabled=!available;add.textContent=available?'Add to Bag — '+(option.dataset.price||''):'Sold out'}
      if(buy)buy.disabled=!available;
      if(window.history&&history.replaceState){const u=new URL(location.href);u.searchParams.set('variant',option.value.split('/').pop());history.replaceState({},'',u)}
    });
  }
  const form=root.querySelector('form.ks-purchase-form');
  if(form){form.addEventListener('submit',async event=>{
    if(event.submitter?.name!=='checkout')return;
    event.preventDefault();event.stopImmediatePropagation();
    if(!buy||buy.disabled)return;
    buy.disabled=true;buy.textContent='Opening checkout…';
    try{const route=(window.Shopify?.routes?.root||'/')+'cart/add.js';const response=await fetch(route,{method:'POST',body:new FormData(form),credentials:'same-origin'});if(!response.ok){const err=await response.json();throw Error(err.description||'Unable to add product')}location.assign((window.Shopify?.routes?.root||'/')+'checkout')}catch(err){buy.disabled=false;buy.textContent='Buy now';alert(err.message||'Please try again')}
  },true)}
}
function ready(){document.querySelectorAll('[data-konsei-product-detail]').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready);else ready();
document.addEventListener('shopify:section:load',ready);
})();